<template>
  <el-dialog :title="form.id?'编辑':'新增'" :visible.sync="formVisible" width="800px" :close-on-click-modal="false">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="120px">
      <el-form-item label="展示位置" prop="displayPosition">
        <el-select v-model="form.displayPosition" placeholder="请选择" @change="changeDisplayPosition">
          <el-option label="首页" :value="1"></el-option>
          <el-option label="开屏页" :value="2"></el-option>
          <el-option label="课程" :value="3"></el-option>
          <!-- 项目落地(4) 不在共用页建，走【营销管理 - 项目落地 - 顶部Banner】专属页 -->
        </el-select>
      </el-form-item>
      <el-form-item label="标题" prop="advertisingTitle">
        <el-input v-model="form.advertisingTitle" placeholder="请输入标题" />
      </el-form-item>
      <el-form-item label="图片" prop="advertisingUrl" class="width100">
        <div class="flexs">
          <imageUpload v-model="form.advertisingUrl" width="50" height="50" />
          <span class="hint">图片限制数量1张<br />建议尺寸710x{{form.displayPosition === 2?'1334':'320'}}像素以上</span>
        </div>
      </el-form-item>
      <el-form-item label="跳转路径" prop="jumpType" v-if="supportsExternal">
        <el-select v-model="form.jumpType" placeholder="请选择" clearable>
          <el-option label="内链" :value="2"></el-option>
          <el-option label="外链" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="地址" prop="jumpUrl" v-if="supportsExternal && form.jumpType==1"
        :rules="[{ required: true, message: '请输入地址',trigger: 'blur'}, { validator: validateJumpUrl, trigger: 'blur' }]">
        <el-input v-model="form.jumpUrl" placeholder="请输入地址" />
        <span v-if="form.displayPosition==1" class="hint">可粘贴意向金配置中的完整购买链接。</span>
      </el-form-item>
      <el-form-item label="跳转类型" prop="advertisingType"
        v-if="usesInternalTarget"
        :rules="[{ required: form.displayPosition==2 && form.jumpType==2, message: '请选择类型',trigger: 'change'}]" >
        <el-select v-model="form.advertisingType" placeholder="请选择" clearable @change="changeType">
          <el-option label="商品管理" :value="1"></el-option>
          <el-option label="积分商品" :value="2"></el-option>
          <el-option label="课程" :value="3"></el-option>
          <el-option label="秒杀商品" :value="4"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="商品类型" prop="goodsAreaId"
        v-if="usesInternalTarget && form.advertisingType==1"
        :rules="[{ required: true, message: '请选择类型',trigger: 'change'}]" >
        <el-select v-model="form.goodsAreaId" clearable placeholder="请选择" @change="getGoods">
          <el-option label="产品商城" :value="3"></el-option>
          <el-option label="零售价兑换专区" :value="4"></el-option>
          <el-option label="学费赠送专区" :value="5"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="内容" prop="value" v-if="usesInternalTarget && form.advertisingType"
        :rules="[{ required: true, message: '请选择内容',trigger: 'change'}]">
        <el-select v-model="form.value" clearable filterable remote :remote-method="remoteSearch" :loading="searchLoading" placeholder="请输入关键词搜索" >
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="排序" prop="orderNo">
        <el-input v-model.number="form.orderNo" placeholder="请输入" />
      </el-form-item>
      <el-form-item label="是否限制时间" prop="timeLimit">
        <el-radio-group v-model="form.timeLimit">
          <el-radio :label="0">不限制</el-radio>
            <el-radio :label="1">限制</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="上下架时间" prop="dateTime" v-if="form.timeLimit"
        :rules="[{ required: true, message: '请选择上下架时间',trigger: 'change'}]">
        <el-date-picker v-model="form.dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
          start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item label="状态">
        <el-switch v-model="form.advertisingStatus" :active-value="1" :inactive-value="0" active-text="上架"
          inactive-text="下架"></el-switch>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()" :loading="isLoading">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  import ImageUpload from "@/components/ImageUpload";
  import sysBannerApi from '@/api/config/sysBanner'
  import sysGoodsApi from '@/api/sys/sysGoods'
  import courseSubjectApi from '@/api/course/courseSubject'
  import { intentPurchaseUrl } from '@/utils/intent-deposit'

  function initFormBean() {
    const formBean = {
      displayPosition: null,
      advertisingTitle: null,
      advertisingUrl: null,
      jumpType: null,
      jumpUrl: null,
      advertisingType: null,
      goodsAreaId:null,
      timeLimit: 0,
      advertisingStatus: 1,
      dateTime: null,
      orderNo: 1,
      value:null
    }
    return formBean
  }

  export default {
    components: {
      ImageUpload
    },
    data() {
      return {
        isLoading:false,
        searchLoading: false,
        form: initFormBean(),
        formVisible: false,
        formRules: {
          displayPosition: [{
            required: true,
            message: '请选择展示位置',
            trigger: 'change'
          }],
          advertisingTitle: [{
            required: true,
            message: '请输入标题',
            trigger: 'blur'
          }],
          unit: [{
            required: true,
            message: '请选择单位',
            trigger: 'change'
          }],
          advertisingUrl: [{
            required: true,
            message: '请选择图片',
            trigger: 'change'
          }],
          timeLimit: [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }]
        },
        options: [],
        subjectQuery:{
          pageNo:1,
          pageSize:50,
        },
        goodsQuery:{
          pageNo:1,
          pageSize:50,
        }
      }
    },
    computed: {
      supportsExternal() { return this.form.displayPosition == 1 || this.form.displayPosition == 2 },
      usesInternalTarget() { return this.form.displayPosition && (!this.supportsExternal || (this.form.jumpType != 1 && (this.form.displayPosition != 2 || this.form.jumpType == 2))) }
    },
    created() {

    },
    methods: {
      validateJumpUrl(rule, value, callback) {
        callback(this.form.displayPosition != 1 || intentPurchaseUrl(value) ? undefined : new Error('请输入完整的 http(s) 购买链接'))
      },
      changeDisplayPosition(){
        if(this.form.displayPosition==2){
          this.$set(this.form,'advertisingType',null)
          this.$set(this.form,'goodsAreaId',null)
          this.$set(this.form,'value',null)
          // this.form.advertisingType=null
          // this.form.goodsAreaId=null
          // this.form.value=null
        }else{
          // this.form.jumpType=null
          // this.form.jumpUrl=null
          this.$set(this.form,'jumpUrl',null)
          this.$set(this.form,'jumpType',this.form.displayPosition==1 ? 2 : null)
          // if(this.form.advertisingType!=1){
          //   this.form.goodsAreaId=null
          //   this.form.value=null
          // }
        }
      },
      // 商品类型切换
      async changeType(e){
        console.log('e: ',e);
        this.$set(this.form,'goodsAreaId','')
        this.$set(this.form,'value','')
        // this.form.goodsAreaId=null
        // this.form.value=null
        if(this.form.advertisingType==1) return
        if(e==3){
          this.getSubject()
        }else{
          this.getGoods()
        }
        // fetchForList
      },
      // 获取商品
      async getGoods(keyword = ''){
        this.form.value=null
        let query={...this.goodsQuery,state:1}
        if(keyword){
          query.name = keyword
        }
        if(this.form.advertisingType==1){
          if(this.form.goodsAreaId==3){
            query.areaCodes='CPSC'
          }
          if(this.form.goodsAreaId==4){
            query.areaCodes='XDB'
          }
          if(this.form.goodsAreaId==5){
            query.areaCodes='ZSZH'
          }
        }else if(this.form.advertisingType==2){
          query.areaCodes='JF'
        }else{
          query.areaCodes='MS'
        }
        const {data} = await sysGoodsApi.listPageForMini(query)
        this.options=data.list.map(i=>({value:i.id,label:i.name}))
        console.log('商品data: ',data);
      },
      // 获取课程列表（带搜索）
      async getSubject(keyword = ''){
        let query={...this.subjectQuery,state:1}
        if(keyword){
          query.name = keyword
        }
        const {data} = await courseSubjectApi.fetchForList(query)
        this.options=data.list.map(i=>({value:i.id,label:i.name}))
        console.log('课程data: ',data);
      },
      // 远程搜索方法
      async remoteSearch(keyword){
        if(!keyword.trim()){
          // 如果搜索关键词为空，重新加载全部数据
          if(this.form.advertisingType==3){
            await this.getSubject()
          }else{
            await this.getGoods()
          }
          return
        }
        this.searchLoading = true
        try {
          if(this.form.advertisingType==3){
            await this.getSubject(keyword)
          }else{
            await this.getGoods(keyword)
          }
        } catch (error) {
          console.error('搜索失败:', error)
        } finally {
          this.searchLoading = false
        }
      },
      // changeVal(e){
      //   console.log('e: ',e);
      //   if(this.form.advertisingType==3){

      //   }else{

      //   }
      // },
      resetForm() {
        this.form = initFormBean()
      },
      handleCreate() {
        this.resetForm()
        this.formVisible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].clearValidate()
        })
      },
      async handleUpdate(row) {
        this.resetForm()
        if(row.advertisingType && row.jumpType!=1){
          if(row.advertisingType==3){
            await this.getSubject()
          }else{
            await this.getGoods()
          }
          // this.changeType(this.form.advertisingType)
        }
        this.form = {
          ...row
        }
        console.log('row',row)
        if(this.form.startTime){
          let arr=[this.form.startTime,this.form.endTime]
          this.$set(this.form,'dateTime',arr)
          // this.form.dateTime.push(...arr)
        }

        if(this.form.advertisingType==3){
          this.$set(this.form,'value',row.courseId)
          // this.form.value=row.courseId
        }else{
          this.$set(this.form,'value',row.goodsId)
          // this.form.value=row.goodsId
        }
        this.formVisible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].clearValidate()
        })
      },
      doCreate() {
        this.$refs["dataForm"].validate((valid) => {
          if (valid) {
            this.isLoading=true
            let params = {
              ...this.form
            }
            if(this.form.advertisingType==3){
              params.courseId=this.form.value
              delete params.goodsId
            }else{
              params.goodsId=this.form.value
              delete params.courseId
            }
            if(this.form.dateTime && this.form.dateTime.length){
              params.startTime = this.form.dateTime[0]
              params.endTime = this.form.dateTime[1]
            }
            if(params.advertisingType!=1){
              delete params.goodsAreaId
            }
            if(!params.advertisingType){
              delete params.advertisingType
              delete params.goodsAreaId
              delete params.goodsId
              if(params.displayPosition!=2 && params.jumpType!=1){
                delete params.jumpUrl
              }
            }
            // 首页和开屏页复用外链；课程仍按原内链处理。
            if(params.displayPosition==1 && params.jumpType!=1) params.jumpType=2
            if(params.displayPosition==1 || params.displayPosition==2){
              if(params.jumpType==1 || !params.jumpType){
                delete params.advertisingType
                delete params.goodsAreaId
                delete params.goodsId
                delete params.courseId
              }else{
                delete params.jumpUrl
              }
              if(!params.jumpType){
                delete params.jumpType
              }
            }else{
              delete params.jumpUrl
              params.jumpType=2
            }
            console.log('params: ', params);
            delete params.dateTime
            delete params.value
            if(this.form.id){
              sysBannerApi.update(params).then((data) => {
                this.postCallback(data)
              }).catch(res=>{
                this.isLoading=false
              });
            }else{
              sysBannerApi.create(params).then((data) => {
                this.postCallback(data)
              }).catch(res=>{
                this.isLoading=false
              });
            }

          }
        });
      },
      postCallback(data) {
        this.$message.success('操作成功')
        this.formVisible = false;
        this.$emit('created')
        this.isLoading=false
      },
    }
  }
</script>
<style lang="scss" scoped>
  ::v-deep .el-select {
    width: 100%;
  }
</style>
